<template>
  <div class="card-management">
    <div class="card-management-dropdown" ref="dropdown" @blur="handleBlur">
      <button
        class="card-management-dropdown-button"
        tabindex="0"
        :class="{ 'is-open': isOpen }"
        @click.prevent="toggleDropdown"
        @keypress.enter.prevent="toggleDropdown"
        @keypress.space.prevent="toggleDropdown"
      >
        <span class="card-management-dropdown-button-label">
          <div
            v-if="selectedCard"
            :class="selectedCard.brand"
            class="card-management--card-logo"
          ></div>
          {{
            selectedCard ? `*** ${selectedCard.last4}` : useANewCreditCardLabel
          }}
        </span>
      </button>
      <div class="card-management-dropdown-content" v-show="isOpen">
        <ul class="card-management-dropdown-content-card-list">
          <div class="dropdown-content-heading" v-if="card.id">
            {{ yourCardsLabel }}
          </div>
          <li
            tabindex="0"
            class="card-management-dropdown-content-card-list--item"
            :class="{ selected: isSelected(card.id) }"
            @click="selectCard(card)"
            @keypress.enter.prevent="selectCard(card)"
            @keypress.space.prevent="selectCard(card)"
          >
            <div :class="card.brand" class="card-management--card-logo"></div>
            <span>*** {{ card.last4 }}</span>
          </li>
          <hr />
          <div class="card-management-dropdown-content-heading">
            {{ addCreditDebitCardLabel }}
          </div>
          <li
            tabindex="0"
            class="card-management-dropdown-content-card-list--item add-card"
            @click="addNewCard"
            @keypress.enter.prevent="addNewCard"
            @keypress.space.prevent="addNewCard"
          >
            <div class="card-management--card-logo generic"></div>
            <span>{{ creditDebitCardLabel }}</span>
          </li>
        </ul>
      </div>
    </div>
    <input
      v-if="selectedCard"
      type="hidden"
      :value="true"
      name="existingCardSelected"
    />
    <div v-if="!selectedCard" class="card-management--card-brands">
      <div class="card-management--card-logo VI"></div>
      <div class="card-management--card-logo MC"></div>
      <div class="card-management--card-logo AX"></div>
      <div class="card-management--card-logo JC"></div>
      <div class="card-management--card-logo UP"></div>
    </div>
    <vgs-form
      v-if="!selectedCard && isUsingVgs"
      ref="vgsForm"
      variant="modify"
      :card-holder="tc('formFields.cardHolder')"
      :card-number-field="tc('formFields.cardNumber')"
      :exp-date-field="tc('formFields.cardExpirationDate')"
      :cvc-field="tc('formFields.cardCvc')"
      :vgs-endpoint="vgsBaseUrl"
      field-class="input"
    />
    <credit-card-form v-if="!selectedCard && !isUsingVgs"/>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CreditCardForm from '@components/05.security/credit-card-form/credit-card-form.vue'

export default {
  name: "card-management",
  components: {
    CreditCardForm
  },
  props: {
    isUsingVgs: {
      type: Boolean,
      default: false
    },
    vgsEndpoint: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedCard: null,
      card: {},
    };
  },
  inject: ['vgsBaseUrl'],
  mounted() {
    if(this.selectedReservations[0]?.guarantee) {
      const cardInfo = this.selectedReservations[0]?.guarantee.split(';')
      this.card = {
        id: 1,
        type: cardInfo[0],
        brand: cardInfo[1],
        last4: cardInfo[2]
      }
    }
    if (Object.keys(this.card).length > 0) {
      this.selectedCard = this.card;
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  computed: {
    ...mapGetters("i18n", ["tc"]),
    ...mapGetters("modifyReservation", ["storedModifyBookingPropData"]),
    ...mapState("modifyReservation", ["selectedReservations"]),
    addCreditDebitCardLabel() {
      return (
        this.storedModifyBookingPropData
          ?.ModifyReservationCardAddCreditDebitCard || ""
      );
    },
    creditDebitCardLabel() {
      return (
        this.storedModifyBookingPropData
          ?.ModifyReservationCardCreditDebitCard || ""
      );
    },
    useANewCreditCardLabel() {
      return (
        this.storedModifyBookingPropData
          ?.ModifyReservationCardUseNewCreditCard || ""
      );
    },
    yourCardsLabel() {
      return (
        this.storedModifyBookingPropData?.ModifyReservationCardYourCards || ""
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
    handleBlur(event) {
      if (!this.$refs.dropdown.contains(event.relatedTarget)) {
        this.closeDropdown();
      }
    },
    closeDropdown() {
      this.isOpen = false;
      document.removeEventListener("click", this.handleOutsideClick);
    },
    selectCard(card) {
      this.selectedCard = card;
      this.closeDropdown();
    },
    isSelected(cardId) {
      return this.selectedCard?.id === cardId;
    },
    addNewCard() {
      this.selectedCard = null;
      this.closeDropdown();
    },
  },
};
</script>
